import { useContext } from "react"
import { AiTeammateContext } from "../context"

export function useAiTeammateContext() {
  return useContext(AiTeammateContext)
}
